<div matDialogTitle class="vehicle-list-scoping__header">
  <h1 class="vehicle-list-scoping__header__title" i18n="@@S_SELECTGROUPS">Select Groups</h1>
  <button mat-icon-button matDialogClose class="vehicle-list-scoping__header__close"><mat-icon>close</mat-icon></button>
</div>

<div matDialogContent class="vehicle-list-scoping__content">
  <fm-scoping-tree [treeData]="treeData" (selectionChange)="onSelectionChange($event)"></fm-scoping-tree>
</div>

<div matDialogActions class="vehicle-list-scoping__actions">
  <span class="vehicle-list-scoping__actions__label">
    <span i18n="@@S_GROUPS_SELECTED">GROUPS SELECTED</span>: {{ selectedNodesCount }}/{{ totalNodesCount }}
  </span>
  <div class="vehicle-list-scoping__actions__buttons btn-uppercase">
    <button
      mat-button
      matDialogClose
      id="btn-tree-scoping-cancel"
      class="vehicle-list-scoping__actions__buttons__cancel btn-uppercase vzc-small"
      i18n="@@S_CANCEL"
    >
      CANCEL
    </button>
    <button
      mat-flat-button
      color="accent"
      id="btn-tree-scoping-save"
      i18n="@@S_SAVE"
      class="vehicle-list-scoping__actions__buttons__save btn-uppercase vzc-small"
      (click)="onSave()"
      [disabled]="selectedNodesCount === 0"
    >
      SAVE
    </button>
  </div>
</div>
